<template>
  <div>
    <div class="tw-pb-10 tw-relative">
      <button
        @click="openAddModal"
        class="tw-rounded-[50%] tw-absolute tw-bottom-0 tw-right-10 tw-w-[50px] tw-bg-[#5022E2] tw-border-0 tw-flex tw-justify-center tw-items-center tw-h-[50px]"
      >
        <feather-icon class="tw-text-white" icon="PlusIcon" />
      </button>

      <div class="tw-flex tw-flex-wrap tw-gap-5">
        <b-link v-for="item in data.details" :key="item.id">
          <card
            :id="item.id"
            :onPlay="() => getLink(item.id)"
            :onDelete="() => showDelete(item.id)"
            :onEdit="() => getDetail(item)"
            :title="item.nama"
            :deskripsi="item.deskripsi"
          />
        </b-link>
      </div>
    </div>

    <!-- Add/Edit Ebook -->
    <b-modal
      id="tambah-ebook"
      size="md"
      ref="modalForm"
      centered
      :title="isEditing ? 'Edit Ebook' : 'Tambah Ebook'"
      cancel-title="Close"
      :ok-title-html="`${isLoadingSubmit ? 'Loading..' : 'Save'}`"
      no-close-on-backdrop
      no-close-on-esc
      :ok-disabled="isLoadingSubmit"
      :cancel-disabled="isLoadingSubmit"
      :hide-header-close="isLoadingSubmit"
      cancel-variant="outline-secondary"
      @hidden="resetModal"
      @ok="submitEbook"
    >
      <b-form>
        <b-form-group label="Nama Ebook" label-for="nama">
          <b-form-input
            v-model="form.nama"
            id="nama"
            placeholder="Masukkaan Nama Ebook"
          />
        </b-form-group>
        <b-form-group label="Link Ebook" label-for="link">
          <b-form-input
            v-model="form.link"
            id="link"
            placeholder="Masukkaan Link Ebook"
          />
        </b-form-group>

        <b-form-group label="Deskripsi Ebook" label-for="deskripsi">
          <b-form-input
            v-model="form.deskripsi"
            id="deskripsi"
            placeholder="Masukkaan Deskripsi Ebook"
          />
        </b-form-group>

        <b-form-group
          v-if="typeof form.file === 'string'"
          label="Preview File"
          label-for="preview-file"
          style="overflow-wrap: break-word"
        >
          <b-link @click="openPreviewFile(form.file)">
            {{ form.file }}
          </b-link>
        </b-form-group>

        <b-form-group label="Pilih File" label-for="file">
          <b-form-file
            id="file"
            v-model="form.file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            accept=".pdf, .PDF"
            @change="handleFileUpload"
          />
        </b-form-group>

        <i class="tw-text-xs tw-text-gray-400">
          *) Yang akan diutamakan adalah file. Jika file tidak diisi, maka link
          yang akan ditampilkan
        </i>
      </b-form>
    </b-modal>

    <!-- Delete Detail Product -->
    <b-modal
      id="hapus-detail-product"
      ref="modalDelete"
      cancel-variant="outline-secondary"
      :ok-title="isLoadingSubmit ? 'Loading...' : 'Hapus'"
      cancel-title="Close"
      no-close-on-backdrop
      no-close-on-esc
      :ok-disabled="isLoadingSubmit"
      :cancel-disabled="isLoadingSubmit"
      :hide-header-close="isLoadingSubmit"
      centered
      title="Hapus Detail Product"
      @ok="deleteProduct"
    >
      <b-form>
        <b-form-group>
          <p>Apakah anda yakin inin menghapus Product ini?</p>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "@vue/composition-api";
import { useRouter } from "@core/utils/utils";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import repository from "@repofactory";
const repoProducts = repository.get("ProductsRepository");
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import Card from "@core/components/video/Card.vue";
import router from "@/router";

import {
  BButton,
  BRow,
  BCol,
  BLink,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormFile,
} from "bootstrap-vue";

export default defineComponent({
  components: {
    BButton,
    FeatherIcon,
    BRow,
    BCol,
    BLink,
    Card,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
  },
  setup() {
    const { route } = useRouter();
    const toast = useToast();

    const data = ref([]);
    const isLoadingSubmit = ref(false);
    const isEditing = ref(false);

    const modalForm = ref(null);
    const modalDelete = ref(null);

    const detailProductId = ref(null);

    const getDetail = async (data) => {
      isEditing.value = true;
      detailProductId.value = data.id;
      form.value = {
        nama: data.nama,
        deskripsi: data.deskripsi,
        link: data.link,
        preview_image: data.preview_image,
        file: data.file,
      };
      modalForm.value.show();
    };

    const showDelete = async (id) => {
      detailProductId.value = id;
      modalDelete.value.show();
    };

    const deleteProduct = async (modal) => {
      try {
        modal.preventDefault();
        isLoadingSubmit.value = true;
        const res = await repoProducts.deleteDetail(detailProductId.value);
        showToast("Notifikasi", res.data.message, "primary");
        modal.vueTarget.hide();
        await fetchData();
      } catch (e) {
        if (e.response.data.message) {
          showToast(
            "Error",
            e.response.data.message,
            "danger",
            "AlertTriangleIcon"
          );
        } else {
          showToast(
            "Error",
            "Error Set Type Products",
            "danger",
            "AlertTriangleIcon"
          );
        }
      } finally {
        isLoadingSubmit.value = false;
      }
    };

    const showToast = (title, text, variant, icon = "BellIcon") => {
      toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          text,
          variant,
        },
      });
    };

    const form = ref({
      nama: null,
      link: null,
      deskripsi: null,
      preview_image: null,
      file: null,
    });

    const resetModal = () => {
      isEditing.value = false;
      detailProductId.value = null;
      form.value = {
        nama: null,
        link: null,
        deskripsi: null,
        preview_image: null,
        file: null,
      };
    };

    const openAddModal = () => {
      isEditing.value = false;
      detailProductId.value = null;
      form.value = {
        nama: null,
        link: null,
        deskripsi: null,
        preview_image: null,
        file: null,
      };
      modalForm.value.show();
    };

    const fetchData = async () => {
      try {
        const res = await repoProducts.getDetail(route.value.params.id);
        data.value = res.data.data;
      } catch (e) {
        if (e.response.data.message) {
          showToast(
            "Error",
            e.response.data.message,
            "danger",
            "AlertTriangleIcon"
          );
        } else {
          showToast(
            "Error",
            "Error Set Type Products",
            "danger",
            "AlertTriangleIcon"
          );
        }
      }
    };

    onMounted(() => {
      fetchData();
    });

    const getLink = (detail_id) => {
      router.push(
        `/ebook-detail/${route.value.params.id}/preview/${detail_id}`
      );
    };

    const detailEbookFormData = (payload) => {
      let formData = new FormData();
      const { nama, link, deskripsi, file } = payload;
      formData.append("nama", nama || "");
      formData.append("link", link || "");
      formData.append("deskripsi", deskripsi || "");
      if (file && typeof file !== "string") {
        formData.append("file", file);
      }
      return formData;
    };

    const submitEbook = async (modal) => {
      try {
        modal.preventDefault();
        isLoadingSubmit.value = true;
        const formData = detailEbookFormData(form.value);
        let res;
        if (isEditing.value) {
          res = await repoProducts.updateDetail(
            detailProductId.value,
            formData
          );
        } else {
          res = await repoProducts.createDetail(
            route.value.params.id,
            formData
          );
        }
        showToast("Notifikasi", res.data.message, "primary");
        modal.vueTarget.hide();
        await fetchData();
      } catch (e) {
        if (e.response && e.response.data && e.response.data.message) {
          showToast(
            "Error",
            e.response.data.message,
            "danger",
            "AlertTriangleIcon"
          );
        } else {
          showToast(
            "Error",
            "Error Submit data products",
            "danger",
            "AlertTriangleIcon"
          );
        }
      } finally {
        isLoadingSubmit.value = false;
      }
    };

    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        form.value.file = file;
      }
    };

    const openPreviewFile = (link) => {
      window.open(link, "_blank");
    };

    return {
      data,
      isLoadingSubmit,
      form,
      modalForm,
      isEditing,
      detailProductId,
      modalDelete,

      // method
      resetModal,
      openAddModal,
      submitEbook,
      getDetail,
      showDelete,
      deleteProduct,
      getLink,
      handleFileUpload,
      openPreviewFile,
    };
  },
});
</script>

<style scoped>
.container {
  height: 100vh;
  overflow: auto;
}
p {
  margin-bottom: 5px;
}
</style>
